import { Main } from './pages/Quiz/Main';

function App() {
  return <Main />;
}

export default App;
